import { SharedConstants } from "../../../shared/constants/shared.constants";
export class CreateApplicationConstants {
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.CREATE_LABEL;
    static DRAFT_BUTTON_PLACEHOLDER = "Save as draft";
    static CONTENT_PAGE_HEADING = "Create application";
    static NAME_INPUT_LABEL = "Name";
    static SURNAME_INPUT_LABEL = "Surname";
    static CREATE_APPLICATION_BUTTON_TEXT = "Create";
    static ERF_INPUT_LABEL = "Erf";
    static ADDRESS_INPUT_LABEL = "Address";
    static REMOVE_ALTERNATIVE_NAME_LABEL = "Remove alternative name ";
    static ADD_ALTERNATIVE_NAME_LABEL = "Add alternative name";
}
